import { FirebaseAnalytics } from "@capacitor-firebase/analytics";
import { compare } from "compare-versions";
import { Utils } from "../../utils";
import { reactAppStage } from "../../utils/reactAppStage";

const versionCheck = async () => {
  if (reactAppStage() !== "demo") return false;
  const v = await Utils.getVersion();
  if (v === "webView") return false;
  const requiredVersion = "0.9.26";

  return compare(v, requiredVersion, ">=");
};

export const setCollectionEnabled = async (enabled: boolean) => {
  if (await versionCheck()) FirebaseAnalytics.setEnabled({ enabled });
};

export const logEvent = async (name: string, params: any) => {
  if (await versionCheck()) FirebaseAnalytics.logEvent({ name, params });
};
